export const imageIcon = {
  height: 647,
  width: 600,
  path: 'M612,619.2H0V172.8h612V619.2z M48.9,570.3H563V221.7H48.9L48.9,570.3L48.9,570.3z M214.2,258.4L85.7,533.7h440.6L416.1,386.9l-67.3,55L214.2,258.4z'
};